import type { Ref } from 'react'
import type { RequisitionMatch } from '../lib/goToRequisition.ts'
import { navigate } from '../lib/route.ts'
import { useGoToRequisition } from '../lib/useGoToRequisition.ts'
import { GoToRequisitionField } from './GoToRequisitionField.tsx'

function open(match: RequisitionMatch): void {
  navigate({
    name: 'verification',
    // By its id only where the ERP fetch created it and named no filial.
    at:
      match.branchCode > 0 || match.verificationId === undefined
        ? { kind: 'numbered', branch: match.branchCode, quotation: match.quotationNumber }
        : { kind: 'identified', id: match.verificationId },
  })
}

/**
 * Opens another requisição from inside a conferência, by number or by scan
 * (#501) -- straight to it, without the queue in between. One the queue does
 * not have yet is fetched from the ERP first.
 */
export function GoToRequisition({ inputRef }: { inputRef?: Ref<HTMLInputElement> }) {
  const field = useGoToRequisition(open)
  return (
    <GoToRequisitionField
      value={field.value}
      state={field.state}
      inputRef={inputRef}
      onChange={field.change}
      onSubmit={field.submit}
      onKeyDown={field.keyDown}
      onPick={field.pick}
      onDismiss={field.dismiss}
    />
  )
}
